webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Progressive Web Novel'
    };
  },

  name: 'App'
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mission: [{ title: 'Empowering Original Indie Web Novel Authors', text: 'Empowering the digital medium literature with web technologies so internet can generate great DIY web novels.' }, { title: 'Embrace Diverse Creativity', text: 'The possible of web novel is massive. Web technologies, browsers, desktop machines, mobile phones, all that internet connects are improving at rapid pace. And web novels can too!' }, { title: 'Reinventing the Craft', text: 'Transitioning between the regular web novel practices to progressive web novels will be daunting, maybe superfluous. However, we believe in taking a step back from the already established a chapter per day daily would benefit authors to hone their craft.' }, { title: 'Knowledge Tank', text: 'We won\'t left you in dark place. In the future, we will compiling lots of knowledge articles reading the craft, whether web development thingy or just plain storytelling craft. Let\'s grow together!' }]
    };
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__(34);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      content: null,
      isActive: false,
      chapter: false,
      items: [{ title: 'PROLOGUE', icon: 'dashboard' }, { title: 'PROLOGUE', icon: 'dashboard' }, { title: 'PROLOGUE', icon: 'dashboard' }, { title: 'PROLOGUE', icon: 'dashboard' }, { title: 'About', icon: 'question_answer' }],
      right: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    axios.get('static/chapters/chapter.json').then(function (response) {
      return _this.content = response;
    }).then(this.isActive = true).then(this.$Progress.finish());
  },
  created: function created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_progressbar__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_progressbar__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
var options = {
  color: '#00ff00',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_progressbar___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>',
  data: {
    vsplash: false
  }
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038ab38c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(20);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-038ab38c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038ab38c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('v-toolbar',{attrs:{"color":"deep-purple","app":"","clipped-left":_vm.clipped}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"transform":"translateY(10px)"},attrs:{"src":"static/img/flat-icons/purple-hat.svg","alt":"John","height":"72px"}})]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('v-toolbar-title',{staticClass:"ml-2"},[_vm._v("Progressive Web Novel "),_c('span',{staticClass:"body-2 ml-1",staticStyle:{"opacity":"0.75","letter-spacing":"1.2px"}},[_vm._v("ALPHA")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-2",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.rightDrawer = !_vm.rightDrawer}}},[_c('v-icon',[_vm._v("menu")])],1)],1),_vm._v(" "),_c('vue-progress-bar'),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"temporary":"","right":_vm.right,"fixed":"","app":"","width":"600"},model:{value:(_vm.rightDrawer),callback:function ($$v) {_vm.rightDrawer=$$v},expression:"rightDrawer"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-container',{staticStyle:{"min-height":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"hover":"","flat":"","color":"blue-grey darken-2","router":"","to":"/the-lab"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-media',{attrs:{"src":"static/img/flat-icons/sword-line.svg","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("e-litRPG")]),_vm._v(" "),_c('div',[_vm._v("It's a RPG, a game! Yet it's a literature!"),_c('br'),_c('br'),_vm._v("The next generation of "),_c('i',[_vm._v("Choose-Your-Own-Adventure")]),_vm._v(" stories... it's super fun!")])])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"flat":"","hover":"","color":"pink darken-1","to":"/dynamic-stories"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Dynamic Stories")]),_vm._v(" "),_c('div',[_vm._v("Whether it's non-linear novel with multiple endings, or code-based generated story elements, these novels will ensure your reading experience fresh and magical.")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-card-media',{attrs:{"src":"static/img/flat-icons/unicorn-line.svg","height":"125px","contain":""}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"flat":"","hover":"","color":"green accent-4","router":"","to":"/the-lab"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-media',{attrs:{"src":"static/img/flat-icons/green-potion-line.svg","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("The Lab")]),_vm._v(" "),_c('div',[_vm._v("Join us in the journey of uncovering the real potentials of web novels, experimenting literature with the ever evolving nature of world wide web.")])])])],1)],1)],1)],1),_vm._v(" "),_c('v-subheader',[_vm._v("Want to contribute?")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"flat":"","hover":"","color":"orange darken-1","router":"","to":"/the-lab"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Support us on Patreon")]),_vm._v(" "),_c('div',[_vm._v("Supports from you give us very warm welcome and motivations to create more awesome things!")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-card-media',{attrs:{"src":"static/img/flat-icons/cookies-line.svg","height":"125px","contain":""}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"flat":"","color":"grey darken-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-card-media',{attrs:{"src":"static/img/flat-icons/desktop-pencil-line.svg","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Join Us! (closed)")]),_vm._v(" "),_c('div',[_vm._v("While we're not looking for new team members during ALPHA phase, maybe in the future it will be different. Who knows?")])])])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"dark":"","height":"auto"}},[_c('v-card',{staticClass:"deep-purple white--text text-xs-center",attrs:{"flat":"","tile":""}},[_c('v-btn',{staticClass:"donate",attrs:{"color":"info","href":"https://www.paypal.me/sidekaraktergendut","target":"_blank"}},[_c('i',{staticClass:"fab fa-paypal"}),_vm._v(" DONATE WITH PAYPAL")]),_vm._v(" "),_c('v-card-text',{staticClass:"white--text pt-0"},[_vm._v("\n        Donations for project funding are welcomed for me to buy a decent machine for web development, plus an HTTPS website\n        hosting in the future."),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"credit"},[_vm._v("Icons made by "),_c('a',{attrs:{"href":"https://www.flaticon.com/","title":"Flaticon"}},[_vm._v("www.flaticon.com")]),_vm._v(" is licensed by "),_c('a',{attrs:{"href":"http://creativecommons.org/licenses/by/3.0/","title":"Creative Commons BY 3.0","target":"_blank"}},[_vm._v("CC 3.0 BY")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"white--text"},[_vm._v("\n        ©2018 — "),_c('strong',[_vm._v("SideKarakterGendut")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_explore__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_the_lab__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dynamic__ = __webpack_require__(32);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */] }, { path: '/explore', component: __WEBPACK_IMPORTED_MODULE_3__components_explore__["a" /* default */] }, { path: '/support-us', component: __WEBPACK_IMPORTED_MODULE_4__components_support__["a" /* default */] }, { path: '/the-lab', component: __WEBPACK_IMPORTED_MODULE_5__components_the_lab__["a" /* default */] }, { path: '/dynamic-stories', component: __WEBPACK_IMPORTED_MODULE_6__components_dynamic__["a" /* default */] }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  meta: {
    progress: {
      func: [{ call: 'color', modifier: 'temp', argument: '#ffb000' }, { call: 'fail', modifier: 'temp', argument: '#6e0000' }, { call: 'location', modifier: 'temp', argument: 'top' }, { call: 'transition', modifier: 'temp', argument: { speed: '1.5s', opacity: '0.6s', termination: 400 } }]
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b65bb86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(25);
function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b65bb86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"route-anim"}},[_c('div',[_c('v-jumbotron',{staticClass:"jumbotronhome elevation-7"},[_c('v-container',{staticStyle:{"max-width":"1300px"},attrs:{"fill-height":"","fixed":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('h3',{staticClass:"home-title display-3 mb-4 mt-5"},[_c('span',{staticStyle:{"opacity":"0.55","letter-spacing":"4px"}},[_vm._v("WELCOME TO")]),_vm._v(" PROG NOVEL")]),_vm._v(" "),_c('p',{staticClass:"subheading ft-quicksand mx-5",staticStyle:{"width":"46%"}},[_vm._v("Witness "),_c('span',{staticClass:"transparent"},[_vm._v("the pure")]),_vm._v(" awesomeness."),_c('span',{staticClass:"transparent"},[_vm._v(" Based on")]),_vm._v(" electronic literature "),_c('span',{staticClass:"transparent"},[_vm._v("forms and the ever evolving nature of")]),_vm._v(" world wide web technologies\n                "),_c('span',{staticClass:"transparent"},[_vm._v("...")]),_vm._v(" "),_c('span',{staticClass:"home-title"},[_vm._v("PROGRESSIVE WEB NOVEL")]),_vm._v(" "),_c('span',{staticClass:"transparent"},[_vm._v("brings the potentials of")]),_vm._v(" web novel "),_c('span',{staticClass:"transparent"},[_vm._v("to the next level.")])]),_vm._v(" "),_c('v-divider',{staticClass:"my-3 mt-3",staticStyle:{"width":"66%","opacity":"0"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto","margin-right":"auto","width":"300px"}},[_c('span',{staticClass:"ft-quicksand",staticStyle:{"letter-spacing":"4px"}},[_vm._v("ready?")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"border-top":"2px #fff solid","border-radius":"0","border-bottom":"0"},attrs:{"flat":"","router":"","to":"/dynamic-stories"}},[_vm._v("EXPLORE PROG NOVELS"),_c('i',{staticClass:"material-icons ml-1"},[_vm._v("chevron_right")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-width":"924px"},attrs:{"fixed":""}},[_c('v-layout',{attrs:{"my-5":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-media',{attrs:{"src":"static/img/flat-icons/desktop-pencil-line.svg","height":"175px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('h2',{staticClass:"mb-3 text-mx-center",staticStyle:{"text-shadow":"2px 2px 2px purple","letter-spacing":"3.2px"}},[_vm._v("WHAT THE HELL IS THIS???")]),_vm._v(" "),_c('p',{staticClass:"text-box mx-3 my-2 px-5 py-4 deep-purple darken-1 elevation-7"},[_vm._v("Progressive Web Novel, well, is web novel. But we don't share the same piloshopy with the mainstream Asian web novel (China, Japan, and Korean WN). Instead, prog novels \n              focus developing our stories based on electronic literature.\n          ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"my-3":""}},[_c('v-flex',{attrs:{"xs9":""}},[_c('h2',{staticClass:"mb-3 text-mx-center",staticStyle:{"text-align":"right","text-shadow":"2px 2px 2px purple","letter-spacing":"3.2px"}},[_vm._v("REINVENTING THE CRAFT")]),_vm._v(" "),_c('p',{staticClass:"text-box mx-3 my-2 px-4 py-4 deep-purple darken-1 elevation-7"},[_vm._v("With different forms we hoped to create different style of works. The whole purpose of the progressive web novel \n              is to reinventing the craft, to dig the real potential of web novels, and find out the best of what this new digital form of literature can offers. Our philosophy regarding web novel is, we don't \n              forget the \"web\" in web novel. Instead, we "),_c('i',[_vm._v("exploit")]),_vm._v(" it."),_c('br'),_c('br'),_vm._v("\n              Check out our Lab segment for the newest experiment!\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-media',{staticClass:"mt-4",attrs:{"src":"static/img/flat-icons/green-potion-line.svg","height":"175px","contain":""}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mission elevation-7"},[_c('h2',[_vm._v("OUR MISSION")]),_vm._v(" "),_c('v-expansion-panel',{staticClass:"elevation-5",staticStyle:{"margin":"20px auto","max-width":"900px"},attrs:{"light":""}},_vm._l((_vm.mission),function(i){return _c('v-expansion-panel-content',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(i.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(i.text)+"\n              ")])],1)],1)}))],1),_vm._v(" "),_c('v-parallax',{staticStyle:{"filter":"saturate(67%)"},attrs:{"src":"static/img/images/cats.webp","height":"375","dark":""}},[_c('v-layout',{staticClass:"team",staticStyle:{"width":"100%"}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',[_vm._v("#OUR TEAM")]),_vm._v(" "),_c('h3',[_vm._v("SideKarakterGendut")]),_vm._v(" "),_c('h4',[_vm._v("Founder, Technomancer, Penomancer")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"15px"},attrs:{"xs4":""}},[_c('div',{staticClass:"elevation-7",attrs:{"id":"mc_embed_signup"}},[_c('form',{staticClass:"validate",attrs:{"action":"https://gilegati.us17.list-manage.com/subscribe/post?u=03ced0ad41d70dc781b7022a9&id=e2345e16d2","method":"post","id":"mc-embedded-subscribe-form","name":"mc-embedded-subscribe-form","target":"_blank","novalidate":""}},[_c('div',{attrs:{"id":"mc_embed_signup_scroll"}},[_c('h4',{staticClass:"email-header"},[_vm._v("Email Subscription")]),_vm._v(" "),_c('hr',{staticClass:"email-line"}),_vm._v(" "),_c('label',{staticClass:"email-text",attrs:{"for":"mce-EMAIL"}},[_vm._v("Subscribe to our mailing list for news and progress")]),_vm._v(" "),_c('input',{staticClass:"email",attrs:{"type":"email","value":"","name":"EMAIL","id":"mce-EMAIL","placeholder":"email address","required":""}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_03ced0ad41d70dc781b7022a9_e2345e16d2","tabindex":"-1","value":""}})]),_vm._v(" "),_c('div',{staticClass:"clear"},[_c('input',{staticClass:"button",attrs:{"type":"submit","value":"SUBSCRIBE","name":"subscribe","id":"mc-embedded-subscribe"}})])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"team"},[_c('v-layout',{staticStyle:{"margin":"30px 0","margin-top":"100px"}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-media',{staticClass:"mb-4",attrs:{"src":"static/img/flat-icons/plug.svg","height":"175px","contain":""}}),_vm._v(" "),_c('h2',{staticClass:"mb-3 text-mx-center h2-feature",staticStyle:{"text-shadow":"2px 2px 2px purple","letter-spacing":"3.2px","text-align":"center"}},[_vm._v("OFFLINE READING")]),_vm._v(" "),_c('p',{staticClass:"text-box mx-4 my-2 px-4 py-4 deep-purple darken-1 elevation-7"},[_vm._v("Thanks to the service worker technology we can deliver to you an offline reading experience,\n            complete with option for add to homescreen, which makes our novel feels like a native app.\n          ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-media',{staticClass:"mb-4",attrs:{"src":"static/img/flat-icons/red-dragon-line.svg","height":"175px","contain":""}}),_vm._v(" "),_c('h2',{staticClass:"mb-3 text-mx-center h2-feature",staticStyle:{"text-align":"center","text-shadow":"2px 2px 2px purple","letter-spacing":"3.2px"}},[_vm._v("AWESOME")]),_vm._v(" "),_c('p',{staticClass:"text-box mx-4 my-2 px-4 py-4 deep-purple darken-1 elevation-7"},[_vm._v("Enganging animations and juicy effects would improve user experience when reading web novel. We're encouraging future prog novel authors how-to-rocks with their novels!\n            "),_c('br'),_vm._v("Be exciting!\n          ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-media',{staticClass:"mb-4",attrs:{"src":"static/img/flat-icons/open-source.svg","height":"175px","contain":""}}),_vm._v(" "),_c('h2',{staticClass:"mb-3 text-mx-center h2-feature",staticStyle:{"text-align":"center","text-shadow":"2px 2px 2px purple","letter-spacing":"3.2px"}},[_vm._v("OPEN SOURCE")]),_vm._v(" "),_c('p',{staticClass:"text-box mx-4 my-2 px-4 py-4 deep-purple darken-1 elevation-7"},[_vm._v("We're sharing because we know, alone, not even in one hundred years we could conquer the vast potential of what the web novel can offers. \n            "),_c('br'),_vm._v(" "),_c('br'),_c('strong',[_vm._v("SO STAY TUNED!")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"road-map-box"},[_c('div',{staticClass:"road-map-hr"}),_vm._v(" "),_c('v-container',{staticClass:"road-map-container",staticStyle:{"max-width":"900px","padding":"45px 150px"}},[_c('h2',{staticClass:"road-map"},[_vm._v("# ROAD MAP")]),_vm._v(" "),_c('h3',[_vm._v("First Demo (ETA 2019~2020)")]),_vm._v(" "),_c('p',{staticClass:"p-road-map"},[_vm._v("First demo using "),_c('a',{attrs:{"href":"https://vuejs.org/"}},[_vm._v("VueJS")]),_vm._v(" and free assets as a prototype for e-litRPG. In the mean time, we wait for "),_c('a',{attrs:{"href":"https://vuepress.vuejs.org/"}},[_vm._v("VuePress")]),_vm._v(", VueJS based static site \n            generator to mature enough \n            to start tinkering with the e-litRPG template--the first project we've got in line.\n          ")]),_vm._v(" "),_c('h3',[_vm._v("Closed Alpha (ETA 2019~2021)")]),_vm._v(" "),_c('p',{staticClass:"p-road-map"},[_vm._v("Closed testing for contributors only.")]),_vm._v(" "),_c('h3',[_vm._v("Open Beta (ETA ???)")]),_vm._v(" "),_c('p',{staticClass:"p-road-map"},[_vm._v("Open for public testing and feedbacks.")]),_vm._v(" "),_c('h3',[_vm._v("First Shipping (ETA ???)")]),_vm._v(" "),_c('p',{staticClass:"p-road-map"},[_vm._v("Releasing VuePress template/theme for making a robust e-litRPG web novel, complete with easy CLI and markdown writing \n            right from your text editor.")]),_vm._v(" "),_c('h3',[_vm._v("Documentation & Tutorials (ETA ???)")]),_vm._v(" "),_c('p',{staticClass:"p-road-map"},[_vm._v("Launch of Prog Novel creator sub-domain for e-litRPG crash course.")]),_vm._v(" "),_c('h3',[_vm._v("Move on to another awesome project...")]),_vm._v(" "),_c('p',{staticClass:"p-road-map"},[_vm._v("Which is still far far far away from now.")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070c9d63_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explore_vue__ = __webpack_require__(27);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070c9d63_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"mt-5"},[_c('v-layout',[_c('v-flex',{staticClass:"px-2",attrs:{"xs8":""}},[_c('div',[_c('v-tabs',{attrs:{"color":"cyan","dark":"","slider-color":"yellow"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((3),function(n){return _c('v-tab',{key:n,attrs:{"ripple":""}},[_vm._v("\r\n                        Item "+_vm._s(n)+"\r\n                    ")])}),_vm._v(" "),_vm._l((3),function(n){return _c('v-tab-item',{key:n},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.text))])],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center mt-3"},[_c('v-btn',{nativeOn:{"click":function($event){return _vm.next($event)}}},[_vm._v("next tab")])],1)],1)]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs4":""}},[_c('iframe',{staticClass:"elevation-5 mt-2",attrs:{"src":"https://discordapp.com/widget?id=459452336050405376&theme=dark","width":"350","height":"500","allowtransparency":"true","frameborder":"0"}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9be9a3bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_lab_vue__ = __webpack_require__(31);
function injectStyle (ssrContext) {
  __webpack_require__(30)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9be9a3bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_lab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"route-anim"}},[_c('div',[_c('div',{staticStyle:{"z-index":"1","top":"100px","left":"calc(50% - 500px)","position":"absolute","max-width":"1000px"}},[_c('v-layout',{attrs:{"my-5":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-media',{staticClass:"grayy mt-4",attrs:{"src":"static/img/flat-icons/working.svg","height":"175px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('h2',{staticClass:"mb-3 text-mx-center",staticStyle:{"text-align":"center","text-shadow":"2px 2px 2px orange","letter-spacing":"3.2px"}},[_vm._v("SORRY... Duh")]),_vm._v(" "),_c('p',{staticClass:"mx-3 my-2 px-5 py-4 orange darken-3 elevation-7"},[_vm._v("We are sorry but currently the project under development. We don't know when we're able to deliver the content, because the framework we're using\n                    isn't mature enough to be used for an open source project. And also, currently, we don't have enough resources to realize our vision. We'll come back later!\n                  ")])])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dynamic_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d81f09b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dynamic_vue__ = __webpack_require__(53);
function injectStyle (ssrContext) {
  __webpack_require__(33)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d81f09b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dynamic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d81f09b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dynamic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"fixed":"","app":"","temporary":""},model:{value:(_vm.chapter),callback:function ($$v) {_vm.chapter=$$v},expression:"chapter"}},[_c('v-toolbar',{staticStyle:{"position":"sticky","top":"0","z-index":"10"},attrs:{"color":"deep-purple darken-1","flat":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"title"},[_vm._v("\n                Chapter List\n            ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.onward = !_vm.onward}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}))],1),_vm._v(" "),_c('div',{attrs:{"id":"dyn-container"}},[_c('v-tooltip',{attrs:{"bottom":"","nudge-top":"10"}},[_c('v-btn',{staticClass:"explore elevation-2",attrs:{"slot":"activator","fab":"","color":"grey darken-2"},on:{"click":function($event){_vm.chapter = !_vm.chapter}},slot:"activator"},[_c('img',{attrs:{"src":__webpack_require__(54),"width":"100%","height":"100%","alt":""}})]),_vm._v(" "),_c('span',[_vm._v("chapters")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","nudge-top":"10"}},[_c('v-btn',{staticClass:"option elevation-2",attrs:{"slot":"activator","fab":"","color":"grey darken-2"},on:{"click":function($event){_vm.chapter = !_vm.chapter}},slot:"activator"},[_c('img',{attrs:{"src":__webpack_require__(55),"width":"100%","height":"100%","alt":""}})]),_vm._v(" "),_c('span',[_vm._v("options")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","nudge-top":"10"}},[_c('v-btn',{staticClass:"share elevation-2",attrs:{"slot":"activator","fab":"","color":"grey darken-2"},on:{"click":function($event){_vm.chapter = !_vm.chapter}},slot:"activator"},[_c('img',{attrs:{"src":__webpack_require__(56),"width":"100%","height":"100%","alt":""}})]),_vm._v(" "),_c('span',[_vm._v("share this")])],1),_vm._v(" "),_c('h1',{staticClass:"header",class:{headerFade: _vm.isActive, header: !_vm.isActive}},[_vm._v(_vm._s(_vm.content.data.novel))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"rate"},[_c('v-layout',[_c('v-flex',[_c('h3',{staticClass:"rate-number"},[_vm._v("88"),_c('span',{staticStyle:{"font-size":"64%"}},[_vm._v("%")])]),_vm._v(" "),_c('h4',{staticClass:"rate-desc"},[_vm._v("people thought this chapter well done")])]),_vm._v(" "),_c('v-flex',{staticClass:"submit"},[_c('div',{staticClass:"submit-desc"},[_vm._v("disagree?")]),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"#fffa"},attrs:{"color":"deep-purple"}},[_vm._v("RATE YOUR SCORE")])],1)],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_vm._v("Content is not ready yet :("),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Please don't mind that rate thingy below. We were experimenting with future feature but too lazy to tidy it up.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[14]);


// WEBPACK FOOTER //
// static/js/app.da4bcd4aef1ab0ae277d.js